import BillView from './BillView'

export default BillView
